import styled, { keyframes } from 'styled-components';

export default function Loading() {
  return (
    <Wrapper>
      <Card>
        <Spinner />
        <Title>Cargando la información de precios</Title>
        <Subtitle>Espera unos segundos...</Subtitle>
      </Card>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  width: 100vw;
  min-height: 100vh;
  display: flex;
  align-items: flex-start;
  justify-content: center;
`;

const Card = styled.div`
  background: #f8f8f8;
  border-radius: 12px;
  padding: 32px 0 28px 0;
  min-width: 540px;
  margin-top: 60px;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-shadow: none;
  @media (max-width: 500px) {
    min-width: 90vw;
    padding: 24px 0 18px 0;
    margin-top: 32px;
  }
`;

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const Spinner = styled.div`
  border: 4px solid #f3f3f3;
  border-top: 4px solid #1756b3;
  border-radius: 50%;
  width: 48px;
  height: 48px;
  animation: ${spin} 1s linear infinite;
  margin-bottom: 24px;
`;

const Title = styled.div`
  color: #0b3254;
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 12px;
  text-align: center;
`;

const Subtitle = styled.div`
  color: #3d5176;
  font-size: 15px;
  text-align: center;
`;
